import apiClient from 'api/client';
import {
  BASE_ENDPOINTS,
  RESOURCES,
  SERVICES,
  VERSIONS
} from '../common/constants';

const SALES_ORDER_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.TRACEABILITY,
  VERSIONS.V1,
  RESOURCES.SALES_ORDER,
  false
);

export const SalesOrderApi = {
  salesOrderForm: () => apiClient.get(`${SALES_ORDER_BASE}/form`),

  editSalesOrderForm: Id =>
    apiClient.get(`${SALES_ORDER_BASE}/form?is_edit=true&sales_order_id=${Id}`),

  createSalesOrder: data => apiClient.post(`${SALES_ORDER_BASE}`, data),

  updateSalesOrder: (id, data) =>
    apiClient.put(`${SALES_ORDER_BASE}/${id}`, data),

  salesOrderReport: () => apiClient.get(`${SALES_ORDER_BASE}/report`)
};
